
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'phone' | 'otp'>('phone');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handlePhoneSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (phone.length >= 9) {
      setIsLoading(true);
      // Simulate API call
      setTimeout(() => {
        setIsLoading(false);
        setStep('otp');
      }, 1500);
    }
  };

  const handleOtpSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 4) {
      setIsLoading(true);
      // Simulate API call
      setTimeout(() => {
        setIsLoading(false);
        navigate('/dashboard');
      }, 1500);
    }
  };

  const handleGuestLogin = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
      {/* Header */}
      <div className="pt-16 pb-8 text-center">
        <div className="w-20 h-20 mx-auto mb-4 bg-blue-600 rounded-3xl flex items-center justify-center animate-bounce-slow">
          <i className="ri-calculator-line text-3xl text-white"></i>
        </div>
        <h1 
          className="text-3xl font-bold text-blue-900 mb-2"
          style={{fontFamily: "Pacifico, serif"}}
        >
          الحاسبة المالية
        </h1>
        <p className="text-blue-600">مرحباً بك مرة أخرى</p>
      </div>

      {/* Form Container */}
      <div className="flex-1 bg-white rounded-t-3xl px-6 pt-8 pb-6 animate-slide-up">
        {step === 'phone' ? (
          <form onSubmit={handlePhoneSubmit} className="space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">تسجيل الدخول</h2>
              <p className="text-gray-500">أدخل رقم جوالك للمتابعة</p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium mb-2">رقم الجوال</label>
                <div className="relative">
                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                    <span className="text-gray-400">+966</span>
                  </div>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="5xxxxxxxx"
                    className="w-full pr-16 pl-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                    maxLength={9}
                  />
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={phone.length < 9 || isLoading}
              className="w-full bg-blue-600 text-white py-4 rounded-2xl font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-200 hover:scale-105 active:scale-95"
            >
              {isLoading ? (
                <div className="flex items-center justify-center space-x-2 space-x-reverse">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>جاري الإرسال...</span>
                </div>
              ) : (
                'إرسال رمز التحقق'
              )}
            </button>

            <div className="text-center space-y-3">
              <button
                type="button"
                onClick={handleGuestLogin}
                className="w-full bg-gray-100 text-gray-700 py-4 rounded-2xl font-semibold text-lg transform transition-all duration-200 hover:scale-105 active:scale-95"
              >
                الدخول كزائر
              </button>
              
              <div>
                <p className="text-gray-500">ليس لديك حساب؟</p>
                <button
                  type="button"
                  onClick={() => navigate('/auth/register')}
                  className="text-blue-600 font-semibold hover:underline"
                >
                  إنشاء حساب جديد
                </button>
              </div>
            </div>
          </form>
        ) : (
          <form onSubmit={handleOtpSubmit} className="space-y-6">
            <div>
              <button
                type="button"
                onClick={() => setStep('phone')}
                className="flex items-center text-blue-600 mb-4"
              >
                <i className="ri-arrow-right-line ml-2"></i>
                العودة
              </button>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">رمز التحقق</h2>
              <p className="text-gray-500">
                أدخل الرمز المرسل إلى +966{phone}
              </p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium mb-2">رمز التحقق</label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 4))}
                  placeholder="0000"
                  className="w-full px-4 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg text-center tracking-widest"
                  maxLength={4}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={otp.length < 4 || isLoading}
              className="w-full bg-blue-600 text-white py-4 rounded-2xl font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-200 hover:scale-105 active:scale-95"
            >
              {isLoading ? (
                <div className="flex items-center justify-center space-x-2 space-x-reverse">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>جاري التحقق...</span>
                </div>
              ) : (
                'تسجيل الدخول'
              )}
            </button>

            <div className="text-center">
              <button
                type="button"
                className="text-blue-600 font-semibold hover:underline"
              >
                إعادة إرسال الرمز
              </button>
            </div>
          </form>
        )}
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-slide-up {
          animation: slide-up 0.5s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }
      `}</style>
    </div>
  );
}
